export default __webpack_public_path__ + "static/media/651.4ad02fb8.jpg";